<template>
  <el-dialog
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    title="编辑资料"
    width="600px"
    @close="close"
  >
    <el-form
      ref="form"
      class="demo-form"
      :label-position="labelPosition"
      label-width="100px"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model.trim="form.name"
          placeholder="请输入姓名"
        />
      </el-form-item>
      <el-form-item label="手机号" prop="tel">
        <el-input
          v-model.trim="form.tel"
          placeholder="请输入手机号"
        />
      </el-form-item>
      <el-form-item label="头像" prop="avatar">
        <el-upload
          :action="QNUploadURL"
          :data="uploadToken"
          :limit="1"
          :multiple="false"
          :before-upload="beforeAvatarUpload"
          class="avatar-uploader"
          :on-success="handleAvatarSuccess"
          :on-remove="image_remove"
          :show-file-list="false"
        >
          <img v-if="form.avatar" class="avatar" :src="form.avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <span>建议尺寸：100px * 100px, 不超过500KB</span>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import storejs from 'store'
import { editUser } from '@/api/branch'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { getUploadToken } from '@/api/app'
export default {
  name: 'EditUser',
  emits: ['fetch-data'],
  data() {
    return {
      labelPosition: 'right',
      QNUploadURL,
      uploadToken:'',
      form: {
        name: '',
        avatar: '',
        tel: '',
      },
      rules: {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' },
        ],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.avatar = QNHost + '/' + res.hash
    },
    image_remove(file, fileList) {
      this.form.avatar = ''
    },
    handleJobAvatarSuccess(res) {
      console.log('res', res.data.url)
      this.form.jobAvatar = res.data.url
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    async showEditUser(user) {
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
      const form = {
        name: user && user.basic && user.basic.name || '',
        avatar: user && user.basic && user.basic.avatar || '',
        tel: user && user.basic && user.basic.tel || '',
      }
      this.form = form
      this.dialogFormVisible = true
    },
    submitForm() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const user = await editUser({
            ...this.form,
          })
          if (!!user) {
            // this.dialogFormVisible = false
            storejs.set('me', user)
            this.$message.success('编辑成功')
            this.$emit('fetch-data', user)
            this.close()
          }

          // this.$baseConfirm(`你确定要修改密码吗`, null, async () => {

          // })
        }
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
  },
}
</script>

<style style="scss" scoped>
:deep(.el-upload) {
  border: 1px dashed #81878f;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.job-avatar {
  width: 335px;
  height: 252px;
  display: block;
}
</style>
